import { render, staticRenderFns } from "./entrAnce.vue?vue&type=template&id=5872c589&scoped=true&"
import script from "./entrAnce.vue?vue&type=script&lang=js&"
export * from "./entrAnce.vue?vue&type=script&lang=js&"
import style0 from "./entrAnce.vue?vue&type=style&index=0&id=5872c589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5872c589",
  null
  
)

export default component.exports